/**
 * I18n Flattener - Allows using flat keys with dot notation
 *
 * Converts hierarchical keys like 'auth.login.agency'
 * to flat keys like 'login.agency' automatically
 */
import { i18n } from './index';

/**
 * Enhanced $t function that handles flat keys
 * Falls back to removing the first namespace if key not found
 */
export function $tf (key: string, ...args: any[]): string {
	// Try the original key first
	let result = i18n.global.t(key, ...(args as [])) as string;

	// If the key wasn't found (still contains the key), try without first namespace
	if (result === key) {
		const parts = key.split('.');
		if (parts.length > 2) {
			// Remove first part: 'auth.login.agency' -> 'login.agency'
			const flatKey = parts.slice(1).join('.');
			result = i18n.global.t(flatKey, ...(args as [])) as string;
		}
	}

	return result;
}

/**
 * Batch key flattening for multiple keys
 */
export function batchFlatten (keys: string[]): Record<string, string> {
	const result: Record<string, string> = {};
	keys.forEach((key) => {
		result[key] = $tf(key);
	});
	return result;
}

/**
 * Debug function to see all available flat keys for a namespace
 */
export function getAvailableKeys (namespace: string): string[] {
	const messages = i18n.global.messages.value.fr;
	const keys = Object.keys(messages).filter(key =>
		key.startsWith(namespace.replace(/^[^.]+\./, '')),
	);
	return keys;
}
